(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-rejeitados', {
            parent: 'app',
            url: '/chamados-rejeitados',
            data: {
                authorities: ['ROLE_PO'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados rejeitados'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-rejeitados/chamados-rejeitados.html',
                    controller: 'ChamadosRejeitadosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
